import React from 'react';

const isBrowser = () => typeof window !== 'undefined';

const userAgent = isBrowser() ? navigator.userAgent : '';

export const UserAgentContext = React.createContext(userAgent);
